import { Flex } from "antd";
import dayjs from "dayjs";

interface IProps {
    issuedWellnessTicket: IIssuedWellnessTicketParam
}

interface IIssuedWellnessTicketParam {
    startDate: string;
    expireDate: string;
    remainingCnt: number;
    totalUsableCnt: number;
    name: string;
    startColor: string;
    endColor: string;
    textColor: string;
}

const Count = ({ issuedWellnessTicket }: IProps) => {
    return (
        <div style={{ width: 'auto', height: 140, borderRadius: 4, background: `linear-gradient(135deg, ${issuedWellnessTicket.startColor}, ${issuedWellnessTicket.endColor})`, padding: '20px', color: issuedWellnessTicket.textColor }}>
            <div className="sub-title/st3">{issuedWellnessTicket.name}</div>
            <div className="body/b1" style={{ marginTop: 4 }}>
                {dayjs(issuedWellnessTicket.startDate).format('YYYY. MM. DD')} -{' '}
                {dayjs(issuedWellnessTicket.expireDate).format('YYYY. MM. DD')}{' '}
                ({dayjs(issuedWellnessTicket.expireDate).diff(dayjs(), 'day')}일 남음)
            </div>
            <Flex style={{ marginTop: 73, alignItems: 'center' }} gap={8}>
                <div className="sub-title/st5" style={{ color: issuedWellnessTicket.textColor }}>{issuedWellnessTicket.totalUsableCnt}회권 </div>
                <div className="body/b1" style={{ color: issuedWellnessTicket.textColor }}>/ 잔여 횟수 {issuedWellnessTicket.remainingCnt}회</div>
            </Flex>
        </div>
    )
}

export default Count